export default [
  '089', // 케이뱅크
  '090', // 한국카카오
]
